import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Inner, Wrapper } from './styles';
export const PresentationalToastNotification = (_a) => {
    var _b;
    var { backgroundColor = 'toastBg', textColor = 'toastText', iconColor = 'toastIcon', leftEdgeColor = 'toastCardLeftEdgeColor', fromTop = false, children, isVisible, onPress } = _a, props = __rest(_a, ["backgroundColor", "textColor", "iconColor", "leftEdgeColor", "fromTop", "children", "isVisible", "onPress"]);
    const asCard = (_b = props.asCard) !== null && _b !== void 0 ? _b : false;
    return (_jsx(Wrapper, { "$backgroundColor": backgroundColor, "$textColor": textColor, "$iconColor": iconColor, "$asCard": asCard, "$fromTop": fromTop, "$leftEdgeColor": leftEdgeColor, "$isVisible": isVisible, onPress: onPress, children: _jsx(Inner, { children: children }) }));
};
export default PresentationalToastNotification;
//# sourceMappingURL=index.js.map